let language = {
    REGIST_FORM_NICKNAME_LABEL: "Full Name",
    REGIST_FORM_NICKNAME_PLACEHOLDER: "Please input your full name",
    REGIST_FORM_NICKNAME_ERROR_TIP1:"Please input 1 to 36 characters(Can including uppercase, lowercase, numbers, and symbols)",
    REGIST_FORM_EMAIL_LABEL: "Email",
    REGIST_FORM_EMAIL_PLACEHOLDER: "Please input a valid email address",
    REGIST_FORM_EMAIL_ERROR_TIP1: "Please enter the correct email address",
    REGIST_FORM_PASSWORD_LABEL: "Password",
    REGIST_FORM_PASSWORD_PLACEHOLDER: "Please enter password",
    REGIST_FORM_PASSWORD_ERROR_TIP1: "Please input 8 to 20 characters(Including uppercase, lowercase, numbers and symbols)",
    REGIST_FORM_PASSWORD_ERROR_TIP2:"Your password cannot be the same as your email address",
    REGIST_FORM_PASSWORD_ERROR_TIP3:"Your password cannot be the same as your account full name",
    REGIST_FORM_REPEAT_PASSWORD_LABEL: "Confirm Password",
    REGIST_FORM_REPEAT_PASSWORD_TIP1: "Your 'confirm password' should be the same as your password",
    REGIST_FORM_REPEAT_PASSWORD_PLACEHOLDER: "Please check password",
    REGIST_FORM_SIGNUP_BTN: "Sign Up",
};

export { language }